import React from 'react';

const ArrowOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <g clipPath="url(#clip0_350_149)">
      <path
        d="M8.40642 15.7471C8.57774 15.9184 8.79842 16.0026 9.02201 16.0026C9.2456 16.0026 9.46919 15.9184 9.63761 15.7471L14.2691 11.1185C14.4317 10.9559 14.5246 10.7323 14.5246 10.5029C14.5246 10.2735 14.4317 10.0499 14.2691 9.88728L9.63761 5.25578C9.29787 4.91604 8.74616 4.91604 8.40642 5.25578C8.06668 5.59552 8.06668 6.14724 8.40642 6.48698L12.4194 10.5L8.40642 14.513C8.06668 14.8527 8.06668 15.4044 8.40642 15.7442V15.7471Z"
        fill="#232325"
      />
      <path
        d="M10.5 21C16.2901 21 21 16.2901 21 10.5C21 4.7099 16.2901 0 10.5 0C4.7099 0 0 4.7099 0 10.5C0 16.2901 4.7099 21 10.5 21ZM10.5 1.74226C15.329 1.74226 19.2577 5.67105 19.2577 10.5C19.2577 15.329 15.329 19.2577 10.5 19.2577C5.67105 19.2577 1.74226 15.329 1.74226 10.5C1.74226 5.67105 5.67105 1.74226 10.5 1.74226Z"
        fill="#232325"
      />
    </g>
    <defs>
      <clipPath id="clip0_350_149">
        <rect width="21" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ArrowOutline;
